import type { useForm } from "hooks";
import type { BootstrapableForm, Option } from "types";
import type { IbanXsBanksCountriesPivot } from "features/openBanking/types";
import { BankingFormField } from "../shared";

export const FormField = {
    ...BankingFormField,
    Flow: 'flow',
    IsEnabled: 'isEnabled',
    Iso2: 'iso2',
    Obs: 'obs',
    Options: 'options',
    OrderNo: 'orderNo',
    ShouldCreditOnRedirect: 'shouldCreditOnRedirect'
} as const;

export type IbanXSBanksCountriesPivot = {
    readonly [FormField.Options]: object;
    readonly [FormField.Iso2]: Array<string>;
    readonly [FormField.Flow]: Option;
} & Pick<
    IbanXsBanksCountriesPivot,
    | 'bankGroup'
    | 'bankId'
    | 'fullName'
    | 'isEnabled'
    | 'recipients_exist'
    | 'logoUrl'
    | 'obs'
    | 'shouldCreditOnRedirect'
>;

export type BootstrapData = {
    readonly BanksFlows: Array<Option>;
    readonly OpenBankingLogosDomain: string;
};

export type IbanXSBanksCountriesPivotForm = Omit<
    BootstrapableForm<IbanXSBanksCountriesPivot, BootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: IbanXSBanksCountriesPivot;
    readonly enableReinitialize?: boolean;
};

export type IbanXSBanksCountriesPivotProps =
    & IbanXSBanksCountriesPivotForm
    & ReturnType<typeof useForm<IbanXSBanksCountriesPivot>>;
